module.exports = __webpack_public_path__ + "img/title-bg1.2dce1f75.png";